module.exports = "<input class=\"form-control font-grey\" type=\"text\" name=\"dp\" [attr.disabled]=\"disabled\" disabled [formControl]=\"parentFormControl\" [minDate]=\"minDate\"\r\n       ngbDatepicker #d=\"ngbDatepicker\" (click)=\"d.toggle()\" autocomplete=\"off\" [placeholder]=\"placeholder\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/date-picker-future-ext/date-picker-future-ext.component.html
// module id = ./src/app/shared/components/date-picker-future-ext/date-picker-future-ext.component.html
// module chunks = main